export interface ILocation {
  city: { [key: string]: string };
  cityId: number;
  continent: { [key: string]: string };
  continentId: number;
  coordinates: { lat: number; lng: number };
  country: { [key: string]: string };
  countryId: number;
  elevation: number;
  state: { [key: string]: string };
  stateId: number;
  timeZone: string;
}

interface PlayerConfig {
  live: boolean;
  playlist?: [];
  parentUrl: string;
  sourceId: string;
  publisherId: string;
  token: string;
  accountId: string;
  advertisment: {
    enabled: boolean;
    adserver: string;
  };
  stream?: string;
  mute: boolean;
  autoplay: boolean;
  language: string;
  stopLiveStreamInSec?: number;
  previewImage: string;
  location?: ILocation;
  logo?: string;
  maintenance?: boolean;
}

export interface Clip {
  variants: [{ id: string; sourceVariantId: string; videoHeight: number; videoBitrate: number; urls: { cdn: string } }];
  medium: {
    sourceVariantId: string;
    mediaUrls: {
      previewImage: {
        cdn: string;
      };
    };
    startTime: string;
  };
  source: {
    location: ILocation;
  };
}

interface EtvConfig {
  egress?: any;
  publisher?: any;
  playlist: {
    id: string;
    accountId: string;
    query: string;
  };
  source: {
    accountId: string;
    alias: string;
    createTime: string;
    description: { [key: string]: string };
    id: string;
    listingStatus: string;
    location?: ILocation;
    maintenance: boolean;
    region: string;
    title: { [key: string]: string };
    updateTime: string;
    userData: { locationId: string };
    visibility: string;
  };
  stream: any;
  streamUris: {
    hls: string;
  };
  target: any;
  template: {
    language: AvailableLanguages;
    advertisement: {
      preroll: {
        enabled: boolean;
      };
      midroll: {
        enabled: boolean;
      };
      postroll: {
        enabled: boolean;
      };
      powerlink: {
        enabled: boolean;
      };
      adserver: string;
    };
    accountId: string;
    analytics: any;
    assets: {
      logo: {
        id: string;
        urls: {
          cdn: string;
          edge: string;
        };
      };
      css: {
        id: string;
        urls: {
          cdn: string;
          edge: string;
        };
      };
    };
    createTime: any;
    id: string;
    name: string;
    playback: {
      autoplay: boolean;
      mute: boolean;
      limit: number;
    };
    overlay: {
      enabled: boolean;
    };
    updateTime: string;
  };
}

enum AvailableLanguages {
  ar = 'ar',
  cn = 'cn',
  de = 'dw',
  en = 'en',
  es = 'es',
  fa = 'fa',
  fr = 'fr',
  ku = 'ku',
  ru = 'ru',
  tr = 'tr',
  uk = 'uk',
  vi = 'vi',
  zh = 'zh',
}

export { PlayerConfig, AvailableLanguages, EtvConfig };
